import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import {
  PageContainer,
  Header,
  FormContainer,
  FormSection,
  FormGrid,
  InputGroup,
  ButtonGroup,
  Button,
  ImageUpload
} from './styles';

const EditAgency = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    logo: null,
    logoFile: null,
    address: '',

    city: '',
    state: '',
    country: '',
    postalCode: '',
    phone: '',
    email: '',
    website: '',
    facebook: '',
    instagram: '',
    twitter: '',
    linkedin: '',
    fax: '',
    idioma: '',
    foundedYear: '',
    license: '',
    specialties: [],
    operatingHours: { weekday: '', saturday: '', sunday: '' },
    active: true
  });

  useEffect(() => {
    // Prefill imediato usando dados enviados pela tela anterior, se disponíveis
    const agencyFromState = location?.state?.agencyDetails;
    if (agencyFromState) {
      setFormData({
        name: agencyFromState.nomeIMOBILIARIA || agencyFromState.name || '',
        description: agencyFromState.descricaoIMOBILIARIA || agencyFromState.description || '',
        logo: agencyFromState.imagemIMOBILIARIA || agencyFromState.logo || null,
        logoFile: null,
        address: agencyFromState.enderecoIMOBILIARIA || agencyFromState.address || '',
        city: agencyFromState.cidadeIMOBILIARIA || agencyFromState.city || '',
        state: agencyFromState.estadoIMOBILIARIA || agencyFromState.state || '',
        country: agencyFromState.paisIMOBILIARIA || agencyFromState.country || '',
        postalCode: agencyFromState.cepIMOBILIARIA || agencyFromState.postalCode || '',
        phone: agencyFromState.telefoneIMOBILIARIA || agencyFromState.phone || '',
        email: agencyFromState.emailIMOBILIARIA || agencyFromState.email || '',
        website: agencyFromState.siteIMOBILIARIA || agencyFromState.website || '',
        facebook: agencyFromState.facebookIMOBILIARIA || agencyFromState.facebook || '',
        instagram: agencyFromState.instagramIMOBILIARIA || agencyFromState.instagram || '',
        twitter: agencyFromState.twitterIMOBILIARIA || agencyFromState.twitter || '',
        linkedin: agencyFromState.linkedinIMOBILIARIA || agencyFromState.linkedin || '',
        fax: agencyFromState.faxIMOBILIARIA || agencyFromState.fax || '',
        idioma: agencyFromState.idiomaIMOBILIARIA || '',
        foundedYear: agencyFromState.anoIMOBILIARIA || agencyFromState.foundedYear || '',
        license: agencyFromState.licencaIMOBILIARIA || agencyFromState.license || '',
        specialties: agencyFromState.specialtiesIMOBILIARIA || agencyFromState.specialties || [],
        operatingHours: agencyFromState.operatingHoursIMOBILIARIA || agencyFromState.operatingHours || { weekday: agencyFromState.horarioSemanaIMOBILIARIA || '', saturday: agencyFromState.horarioSabadoIMOBILIARIA || '', sunday: agencyFromState.horarioDomingoIMOBILIARIA || '' },
        active: String(agencyFromState.ativoIMOBILIARIA ?? '1') === '1'
      });
    }

    const fetchAgencyDetails = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_URL_API}/imobiliarias/${id}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
            'accept': 'application/json'
          }
        });
        const agency = await response.json();
        setFormData({
          name: agency.nomeIMOBILIARIA || '',
          description: agency.descricaoIMOBILIARIA || '',
          logo: agency.imagemIMOBILIARIA || null,
          logoFile: null,
          address: agency.enderecoIMOBILIARIA || '',
          city: agency.cidadeIMOBILIARIA || '',
          state: agency.estadoIMOBILIARIA || '',
          country: agency.paisIMOBILIARIA || '',
          postalCode: agency.cepIMOBILIARIA || '',
          phone: agency.telefoneIMOBILIARIA || '',
          email: agency.emailIMOBILIARIA || '',
          website: agency.siteIMOBILIARIA || '',
          facebook: agency.facebookIMOBILIARIA || '',
          instagram: agency.instagramIMOBILIARIA || '',
          twitter: agency.twitterIMOBILIARIA || '',
          linkedin: agency.linkedinIMOBILIARIA || '',
          fax: agency.faxIMOBILIARIA || '',
          idioma: agency.idiomaIMOBILIARIA || '',
          foundedYear: agency.anoIMOBILIARIA || '',
          license: agency.licencaIMOBILIARIA || '',
          specialties: agency.specialtiesIMOBILIARIA || agency.specialties || [],
          operatingHours: agency.operatingHoursIMOBILIARIA || { weekday: agency.horarioSemanaIMOBILIARIA || '', saturday: agency.horarioSabadoIMOBILIARIA || '', sunday: agency.horarioDomingoIMOBILIARIA || '' },
          active: String(agency.ativoIMOBILIARIA ?? '1') === '1'
        });
      } catch (error) {
        console.error('Error fetching agency details:', error);
      }
    };

    if (id) {
      fetchAgencyDetails();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(prev => ({ ...prev, logo: reader.result, logoFile: file }));
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveLogo = (e) => {
    e?.preventDefault?.();
    setFormData(prev => ({ ...prev, logo: null, logoFile: null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem('auth_token');
      const fd = new FormData();
      // Envie somente campos que existem/preenchidos (PATCH parcial)
      if (formData.name) fd.append('nomeIMOBILIARIA', formData.name);
      if (formData.description) fd.append('descricaoIMOBILIARIA', formData.description);
      if (formData.address) fd.append('enderecoIMOBILIARIA', formData.address);
      if (formData.city) fd.append('cidadeIMOBILIARIA', formData.city);
      if (formData.state) fd.append('estadoIMOBILIARIA', formData.state);
      if (formData.country) fd.append('paisIMOBILIARIA', formData.country);
      if (formData.postalCode) fd.append('cepIMOBILIARIA', formData.postalCode);
      if (formData.phone) fd.append('telefoneIMOBILIARIA', formData.phone);
      if (formData.email) fd.append('emailIMOBILIARIA', formData.email);
      if (formData.website) fd.append('siteIMOBILIARIA', formData.website);
      if (formData.facebook) fd.append('facebookIMOBILIARIA', formData.facebook);
      if (formData.instagram) fd.append('instagramIMOBILIARIA', formData.instagram);
      if (formData.twitter) fd.append('twitterIMOBILIARIA', formData.twitter);
      if (formData.linkedin) fd.append('linkedinIMOBILIARIA', formData.linkedin);
      if (formData.fax) fd.append('faxIMOBILIARIA', formData.fax);
      if (formData.idioma) fd.append('idiomaIMOBILIARIA', formData.idioma);
      if (formData.foundedYear) fd.append('anoIMOBILIARIA', String(formData.foundedYear));
      if (formData.license) fd.append('licencaIMOBILIARIA', formData.license);
      if (typeof formData.active !== 'undefined') fd.append('ativoIMOBILIARIA', formData.active ? '1' : '0');
      // Horários (JSON + campos separados)
      try {
        const hours = formData.operatingHours || {};
        if (hours && (hours.weekday || hours.saturday || hours.sunday)) {
          fd.append('operatingHoursIMOBILIARIA', JSON.stringify({
            weekday: hours.weekday || '',
            saturday: hours.saturday || '',
            sunday: hours.sunday || ''
          }));
          if (hours.weekday) fd.append('horarioSemanaIMOBILIARIA', hours.weekday);
          if (hours.saturday) fd.append('horarioSabadoIMOBILIARIA', hours.saturday);
          if (hours.sunday) fd.append('horarioDomingoIMOBILIARIA', hours.sunday);
        }
      } catch {}
      // Especialidades
      if (Array.isArray(formData.specialties) && formData.specialties.length > 0) {
        try { fd.append('specialtiesIMOBILIARIA', JSON.stringify(formData.specialties)); } catch {}
      }
      if (formData.logoFile) fd.append('imagemIMOBILIARIA', formData.logoFile, formData.logoFile.name);

      const resp = await fetch(`${import.meta.env.VITE_URL_API}/imobiliarias/${id}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json'
        },
        body: fd
      });
      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(txt || 'Falha ao atualizar agência');
      }
      navigate('/dashboard/agency');
    } catch (err) {
      console.error('Error updating agency:', err);
      alert(err.message || 'Erro ao atualizar agência');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = () => {
    if (window.confirm('Tem certeza que deseja excluir esta agência?')) {
      fetch(`${import.meta.env.VITE_URL_API}/imobiliarias/${id}`, {
        method: 'DELETE',
      })
        .then(response => {
          if (response.ok) {
            navigate('/dashboard/agency');
          } else {
            console.error('Error deleting agency:', response.statusText);
          }
        })
        .catch(error => console.error('Error deleting agency:', error));
    }
  };

  return (
    <PageContainer>
      <Header>
        <h1>{id ? 'Editar Agência' : 'Nova Agência'}</h1>
      </Header>

      <form onSubmit={handleSubmit}>
        <FormContainer>
          <FormSection>
            <h2>Informações Básicas</h2>
            <FormGrid>
              <InputGroup className="full-width">
                <label>Logo da Agência</label>
                <ImageUpload>
                  <input type="file" accept="image/*" onChange={handleFileChange} />
                  {!formData.logo ? (
                    <>
                      <div className="icon">📷</div>
                      <div className="text">Clique ou arraste uma imagem</div>
                    </>
                  ) : (
                    <>
                      <img src={formData.logo} alt="Logo" className="preview" />
                      <button className="remove" onClick={handleRemoveLogo}>×</button>
                    </>
                  )}
                </ImageUpload>
              </InputGroup>
              <InputGroup className="full-width">
                <label>Nome da Agência</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup className="full-width">
                <label>Descrição</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
            </FormGrid>
          </FormSection>

          <FormSection>
            <h2>Localização</h2>
            <FormGrid>
              <InputGroup className="full-width">
                <label>Endereço</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>Cidade</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>Distrito</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>País</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>Código Postal</label>
                <input
                  type="text"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
            </FormGrid>
          </FormSection>

          <FormSection>
            <h2>Contato</h2>
            <FormGrid>
              <InputGroup>
                <label>Telefone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>Fax</label>
                <input
                  type="text"
                  name="fax"
                  value={formData.fax}
                  onChange={handleChange}
                  placeholder="Opcional"
                />
              </InputGroup>
              <InputGroup>
                <label>Idioma</label>
                <select name="idioma" value={formData.idioma} onChange={handleChange}>
                  <option value="">Selecione</option>
                  <option value="pt-BR">Português (Brasil)</option>
                  <option value="pt-PT">Português (Portugal)</option>
                </select>
              </InputGroup>
              <InputGroup>
                <label>Website</label>
                <input
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                />
              </InputGroup>
            </FormGrid>
          </FormSection>

          <FormSection>
            <h2>Redes Sociais</h2>
            <FormGrid>
              <InputGroup>
                <label>Facebook</label>
                <input
                  type="url"
                  name="facebook"
                  value={formData.facebook}
                  onChange={handleChange}
                />
              </InputGroup>
              <InputGroup>
                <label>Instagram</label>
                <input
                  type="url"
                  name="instagram"
                  value={formData.instagram}
                  onChange={handleChange}
                />
              </InputGroup>
              <InputGroup>
                <label>Twitter</label>
                <input
                  type="text"
                  name="twitter"
                  value={formData.twitter}
                  onChange={handleChange}
                  placeholder="@seuusuario"
                />
              </InputGroup>
              <InputGroup>
                <label>LinkedIn</label>
                <input
                  type="url"
                  name="linkedin"
                  value={formData.linkedin}
                  onChange={handleChange}
                  placeholder="linkedin.com/company/sua-agencia"
                />
              </InputGroup>
            </FormGrid>
          </FormSection>

          <FormSection>
            <h2>Informações Adicionais</h2>
            <FormGrid>
              <InputGroup>
                <label>Ano de Fundação</label>
                <input
                  type="text"
                  name="foundedYear"
                  value={formData.foundedYear}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <label>Licença (AMI)</label>
                <input
                  type="text"
                  name="license"
                  value={formData.license}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup className="full-width">
                <label>Horário de Funcionamento</label>
                <FormGrid>
                  <InputGroup>
                    <label>Dias Úteis</label>
                    <input
                      type="text"
                      name="weekday"
                      value={formData.operatingHours.weekday}
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        operatingHours: { ...prev.operatingHours, weekday: e.target.value }
                      }))}
                      placeholder="9:00 - 18:00"
                    />
                  </InputGroup>
                  <InputGroup>
                    <label>Sábado</label>
                    <input
                      type="text"
                      name="saturday"
                      value={formData.operatingHours.saturday}
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        operatingHours: { ...prev.operatingHours, saturday: e.target.value }
                      }))}
                      placeholder="10:00 - 14:00"
                    />
                  </InputGroup>
                  <InputGroup>
                    <label>Domingo</label>
                    <input
                      type="text"
                      name="sunday"
                      value={formData.operatingHours.sunday}
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        operatingHours: { ...prev.operatingHours, sunday: e.target.value }
                      }))}
                      placeholder="Fechado"
                    />
                  </InputGroup>
                </FormGrid>
              </InputGroup>
              <InputGroup className="full-width">
                <label>Especialidades (separe por vírgula)</label>
                <input
                  type="text"
                  name="specialtiesInput"
                  value={Array.isArray(formData.specialties) ? formData.specialties.join(', ') : ''}
                  onChange={(e) => setFormData(prev => ({
                    ...prev,
                    specialties: e.target.value.split(',').map(s => s.trim()).filter(Boolean)
                  }))}
                  placeholder="Residencial, Comercial"
                />
              </InputGroup>
              <InputGroup>
                <label>
                  <input
                    type="checkbox"
                    checked={!!formData.active}
                    onChange={(e) => setFormData(prev => ({ ...prev, active: e.target.checked }))}
                    style={{ width: 22, height: 22, marginTop: 6, marginRight: 8, verticalAlign: 'middle' }}
                  />{' '}
                  Agência ativa
                </label>
              </InputGroup>
            </FormGrid>
          </FormSection>

          <ButtonGroup>
            <Button 
              type="button" 
              className="secondary"
              onClick={() => navigate('/dashboard/agency')}
            >
              Cancelar
            </Button>
            {id && (
              <Button 
                type="button" 
                className="danger"
                onClick={handleDelete}
                style={{ marginLeft: 12 }}
              >
                Excluir Agência
              </Button>
            )}
            <Button type="submit" className="primary" disabled={isSubmitting} style={{ marginLeft: 12 }}>
              {isSubmitting ? 'Salvando...' : (id ? 'Salvar alterações' : 'Criar Agência')}
            </Button>
          </ButtonGroup>
        </FormContainer>
      </form>
    </PageContainer>
  );
};

export default EditAgency;